/** Production URLs embedded in copied email signatures (must be publicly reachable). */
export const VIVA_SIGNATURE_PUBLIC_ORIGIN = 'https://vivapsychotherapy.com'

export const VIVA_SIGNATURE_LOGO_URL = `${VIVA_SIGNATURE_PUBLIC_ORIGIN}/img/logo/Logo-nobg-300x300.png`

export const VIVA_SIGNATURE_LOGO_WIDTH_PX = 120

export const VIVA_SIGNATURE_ICON_BASE = `${VIVA_SIGNATURE_PUBLIC_ORIGIN}/assets/email-signature/icons`

export const VIVA_SIGNATURE_ADDRESS =
  '5301 N Federal Highway, Suite 200, Boca Raton/FL - 33487'

export const VIVA_SIGNATURE_DEFAULTS = {
  name: 'Lidiana Cartolano',
  role: [
    'Licensed Mental Health Counselor - LMHC',
    'National Certified Counselor - NCC',
    'EMDR Therapist - EMDRIA',
    'Owner | VIVA Psychotherapy',
  ].join('\n'),
  phone: '(561) 759-7519',
  email: 'lidiana@vivapsychotherapy.com',
  websiteUrl: 'https://www.vivapsychotherapy.com/',
  address: VIVA_SIGNATURE_ADDRESS,
  fontKey: 'helvetica',
}

export const SIGNATURE_FONT_OPTIONS = [
  {
    key: 'helvetica',
    label: 'Helvetica Neue',
    stack: "'Helvetica Neue', Helvetica, Arial, sans-serif",
  },
]

export function resolveSignatureFontStack(fontKey) {
  const found = SIGNATURE_FONT_OPTIONS.find((f) => f.key === fontKey)
  return found?.stack ?? SIGNATURE_FONT_OPTIONS[0].stack
}

export function getSignaturePreviewAssets(origin) {
  const base = String(origin || VIVA_SIGNATURE_PUBLIC_ORIGIN).replace(/\/$/, '')
  return {
    assetBase: `${base}/assets/email-signature/icons`,
    logoUrl: `${base}/img/logo/Logo-nobg-300x300.png`,
  }
}
